import * as moment from 'moment';


export class Campaign
{
  public static readonly STATUS_CREATED = 'CREATA';
  public static readonly STATUS_SUMMARY= 'IN RIEPILOGO';
  public static readonly STATUS_DEFINED = 'DEFINITA';
  public static readonly STATUS_GENERATING = 'IN ELABORAZIONE';
  public static readonly STATUS_ELABORATA = 'ELABORATA';
  public static readonly STATUS_READY = 'PRONTA';
  public static readonly STATUS_LIVE = 'LIVE';
  public static readonly STATUS_CONCLUDED = 'CONCLUSA';
  public static readonly STATUS_EVALUATED = 'VALUTATA';
  public static readonly STATUS_ELIMINATA = 'ELIMINATA';

  // Probabilmente inutili
  public static readonly STATUS_APPROVED = 'APPROVED';
  public static readonly STATUS_SENT_KCM = 'INVIATA_A_KCM';
  //

  public static readonly COUPON_TRADE_DRIVER = 1;
  public static readonly COUPON_CATEGORY = 2;
  public static readonly COUPON_PRODUCT = 4;

  public static readonly TYPE_ONE_SHOT = 1;
  public static readonly TYPE_RECURRING = 2;


  // form requests cache
  public getCreateCampaignFormData: any;
  public getCreateCampaignDefaultFormData: any;
  public getSegments: any;

  // header
  public name: string;

  // step 1
  public goalId: number;
  public targetId: number;

  // step 2
  public type: number;
  public priority: number;
  public bypass: number;
  public channels: Array<number>;
  public emissionStartDate: Date;
  public emissionEndDate: Date;
  public redemptionStartDate: Date;
  public redemptionEndDate: Date;
  public flagOpenRedemptionPeriod: boolean;
  public flagAllSelectedChannels: boolean;
  public flagOnlyCardHolder: boolean;
  public flagOnlyLoyaltyCard: boolean;
  public channelCodeList: string;

  // step 3
  public budget: number;
  public percentageDiscount: number;
  public monetaryDiscount: number;
  public loyaltyPoints: number;
  public notes: string;

  // step 4
  public storesId: Array<string>;
  public stores: Array<any>;
  public segments: Array<string>;
  public coupons: Array<any>;


  constructor(campaignData?: any)
  {
    if(typeof campaignData === 'undefined') {
      return;
    }

    this.name = campaignData.campaignName;
    this.goalId = campaignData.focusCode;
    this.targetId = campaignData.businessGoalCode;

    this.type = campaignData.campaignTypeCode;
    this.priority = campaignData.campaignPriorityCode;
    this.bypass = campaignData.flagCustomerPressureRule;

    this.channels = [ campaignData.channelCode ];
    this.emissionStartDate = moment(campaignData.emissionStartDate, 'DD/MM/YYYY').toDate();
    this.emissionEndDate = moment(campaignData.emissionEndDate, 'DD/MM/YYYY').toDate();
    this.redemptionStartDate = moment(campaignData.redemptionStartDate, 'DD/MM/YYYY').toDate();
    this.redemptionEndDate = moment(campaignData.redemptionEndDate, 'DD/MM/YYYY').toDate();
    this.flagOpenRedemptionPeriod = campaignData.flagOpenRedemptionPeriod == 1;
    this.flagAllSelectedChannels = campaignData.flagAllSelectedChannels == 1;
    this.flagOnlyCardHolder = campaignData.flagOnlyCardHolder == 1;
    this.flagOnlyLoyaltyCard = campaignData.flagOnlyLoyaltyCard == 1;

    this.notes = campaignData.notes;
    this.budget = campaignData.budget;
    this.percentageDiscount = campaignData.budgetInModel.prcPercentageDiscount;
    this.monetaryDiscount = campaignData.budgetInModel.prcMonetoryDiscount;
    this.loyaltyPoints = campaignData.budgetInModel.prcLoyaltyPoints;

    if(campaignData.targetedStores) {
      this.storesId = campaignData.targetedStores.split(',');
    }

    if(campaignData.segments) {
      this.segments = campaignData.segments.split('-');
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/campaign.ts